module.exports = __webpack_public_path__ + "media/images/photo/plans/places/gion-4e76b0e6fbe9d4e9cd2e57d28bd5c95e.png";